import {
  accessAuto1,
  accessAutoMain,
  accessLite1,
  accessPro1,
  accessProMain,
  accessProSchemeThumb,
  accesscontroller1,
  accesscontrollerMain,
} from '@assets/images/main/access/product';
import { IconBookmark, IconDownload, IconInfo, IconKey, IconPhone, IconPlug, IconPower, IconShare, IconThumbUp, IconUser } from '@assets/images/icon';
import { accessMainKey4, IconCard, IconTopology } from '@assets/images/main';

export default {
  a: [
    { text: 'Technology Type', icon: IconInfo },
    { text: 'Mobile Access', icon: IconPhone },
    { text: 'NFC Access', icon: IconCard },
    { text: 'Face Recognition Access', icon: IconUser },
    { text: 'Access Tag', icon: IconKey },
    { text: 'Access Log Storage', icon: IconDownload },
    { text: 'Power Input', icon: IconPlug },
    { text: 'Server Communication', icon: IconTopology },
    { text: 'Primary Use Cases', icon: IconBookmark },
    { text: 'Recommended Environment', icon: IconThumbUp },
    { text: 'External Integration', icon: IconShare },
  ],

  b: [
    { text: 'Bluetooth 5, Microwave' },
    { text: 'Supported' },
    { text: 'Not Supported' },
    { text: 'Not Supported' },
    { text: 'Not Supported' },
    { text: 'Entry Log Storage' },
    { text: 'DC 12V, 24V (non-polarity)' },
    { text: 'Wi-Fi' },
    { text: 'Apartments, dormitories, hospitals, and other automated spaces' },
    { text: 'Vehicle tracking, asset tracking' },
    { text: 'Not Supported' },
  ],

  c: [
    { text: 'Bluetooth 5, NFC' },
    { text: 'Supported' },
    { text: 'Supported' },
    { text: 'Not Supported' },
    { text: 'Supported' },
    { text: 'Access Log Storage' },
    { text: 'PoE' },
    { text: 'PoE' },
    { text: 'Smart offices, studios, shared facilities, etc.' },
    { text: 'Vehicle tracking, asset tracking' },
    { text: 'API Provided' },
  ],

  d: [
    { text: 'Bluetooth 5, NFC, AI' },
    { text: 'Supported' },
    { text: 'Supported' },
    { text: 'Supported' },
    { text: 'Supported' },
    { text: 'Access Log Storage' },
    { text: '12V / 3A Adapter' },
    { text: 'PoE, Wi-Fi' },
    { text: 'Premium buildings, common entrances, access control rooms, etc.' },
    { text: 'Yards, ports, logistics centers, construction sites, etc.' },
    { text: 'API Provided' },
  ],

  spec: [
    {},

    {
      image: accessAutoMain,
      link: '/access/auto',
      title: 'Access Auto',
      desc: '',
    },

    {
      image: accessLite1,
      link: '/access/lite',
      title: 'Access Lite',
      desc: '',
    },

    {
      image: accessProSchemeThumb,
      link: '/access/pro',
      title: 'Access Pro',
      desc: '',
    },
  ],
};
